import React, { PureComponent } from 'react'
import './wallet.css'
import { Input, Button, Form, Modal, Tooltip, Icon } from 'antd'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import { connect } from 'react-redux'
import { finishWallet } from '../../redux-flow/actions/wallet'
import { completeSignUp } from '../../redux-flow/actions/users'
import { infoRequired, validatePassword } from '../../utils/validators'
import LoginWallet from './loginWallet'
import { getInfoLocalStorage } from '../../utils/api'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import walletImg from '../../images/wallet.png'
import { maskTelefoneOnChange as maskTelefone, } from '../../utils/masks'
import { validateTelefone } from '../../utils/validators'

const NomeFiliacao = () => (
    <><label className="mr-2">Filiação</label><Tooltip title="Preencher com o nome completo da primeira filiação que consta em seu documento de identidade. Ex.: Nome completo da mãe"><FontAwesomeIcon icon={faInfoCircle} /></Tooltip></>
 )

const NomeCelular = () => (
    <><label className="mr-2">Celular</label><Tooltip title="Certifique-se de que o número de celular está correto. Poderemos solicitar verificação via SMS em alguns de nossos serviços."><FontAwesomeIcon icon={faInfoCircle} /></Tooltip></>
)

const NomeSenha = () => (
    <><label className="mr-2">Nova senha</label><Tooltip title={`Esta será sua nova senha de acesso a plataforma ${process.env.REACT_APP_NAME}`}><FontAwesomeIcon icon={faInfoCircle} /></Tooltip></>
)

const setStateLocalStorage = getInfoLocalStorage()

const LoadingComponent = () => (
    <div style={{ textAlign: 'center' }}>
        <Icon type="loading" />
    </div>
)

const BtnDisabled = () => (
    <div className="novoContratoDisabled mt-3 d-flex justify-content-center">
        <Tooltip title="Por favor, complete seu cadastro.">
            <button type="button" className="btnGrafico w-50">
                Criar wallet
            </button>
        </Tooltip>
    </div>
)

const mapStateToProps = state => ({
    userid: state.login.userid,
    successCreation: state.wallet.successCreation,
    success: state.wallet.success,
    message: state.wallet.message,
    creationToken: state.wallet.creationToken,
    completeLoading: state.users.completeLoading,
    completeSuccess: state.users.success,
    completeMessage: state.users.message,
    isLoadingSMS: state.wallet.isLoadingSMS,
    isLoading: state.wallet.isLoading,
    addressCreation: state.wallet.addressCreation
})

const mapDispatchToProps = dispatch => ({
    handleSubmit: (creationToken, userid, form) => e => {
        e.preventDefault()
        dispatch(finishWallet(creationToken, userid, form))
    },
    completeSignUp: (form, userid) => e => {
        e.preventDefault()
        dispatch(completeSignUp(form, userid))
    }
})

const CODE_LENGTH = new Array(6).fill(0);

// const CreationForm = Form.create({ name: 'create-wallet' })(
//     connect(mapStateToProps, mapDispatchToProps)(
//     ({ form, handleSubmit, token, userid, isLoading, ultimos, resendSMS, isLoadingSMS }) => (
//             <Form
//                 onSubmit={handleSubmit(token, userid, form)}
//             >
//             {/* <p className='verificationMessage'>Enviamos um código de verificação para o número de final {ultimos}. <b><Tooltip title="Entre em contato conosco através do chat para que possamos alterar seu cadastro.">Não é você?</Tooltip></b></p> */}
//                 {/* <Form.Item
//                     name="sms"
//                     label="SMS"
//                 >
//                     {form.getFieldDecorator('sms', {
//                             rules: [ infoRequired ]
//                         })(
//                         <Input className="formInput" placeholder="SMS" disabled={isLoading ? true : false} />
//                         )}
//                 </Form.Item>
//                 {isLoadingSMS ? <LoadingComponent /> : 
//                 <p className='codeAgainMessage mt-3'>Não recebeu o código? <b className="tx-pink" role="button" onClick={resendSMS}>  Clique aqui</b> para reenviar.</p>}
                
//                 <hr className='hrSms'/>
//                 <Form.Item
//                     name="password"
//                     label="Senha"
//                 >
//                     {form.getFieldDecorator('password', {
//                             rules: [ infoRequired ]
//                         })(
//                         <Input.Password  className="formInput" placeholder="Senha" disabled={isLoading ? true : false} />
//                     )}
//                 </Form.Item>   */}
//                     {isLoading ? <LoadingComponent /> :                                         
//                     <button className="mt-5 text-center btnGrafico w-100">Criar Wallet</button> }
//             </Form>
//         )
//     )
// )

const CompleteForm = Form.create({ name: 'complete-signup' })(
    connect(mapStateToProps, mapDispatchToProps)(
    ({ form, completeSignUp, userid, completeLoading, completeSuccess, completeMessage }) => (
        
        <div className="cadastroWalletForm">
            <div className="alert alert-danger text-center mb-5 cursor-pointer" role="alert">
                Estamos aprimorando a experiência e a segurança dos dados de nossos clientes. Por isso, solicitamos que atualize seu cadastro de acordo com nosso novo padrão, antes de prosseguir para a criação de sua Flow.in Wallet.
        </div>
            <Form
                onSubmit={completeSignUp(form, userid)}
            >
                {
                    !completeSuccess && completeMessage != null ? 
                    <div className="alert alert-danger text-center mb-5 cursor-pointer" role="alert">
                        {completeMessage}
                    </div> : ''
                }
                <Form.Item label={<NomeFiliacao />}>
                    {form.getFieldDecorator('nomeMae', {
                        rules: [
                            infoRequired,
                        ]
                    })(
                        <Input placeholder="Filiação" />
                    )}
                </Form.Item>
                <Form.Item label={<NomeCelular />}>
                    {form.getFieldDecorator('telefone', {
                        rules: [
                            infoRequired,
                            validateTelefone()
                        ]
                    })(
                        <Input type='text' placeholder="Número de celular" onChange={maskTelefone} onKeyPress={maskTelefone} />
                    )}
                </Form.Item>
                <Form.Item label="RG">
                    {form.getFieldDecorator('rg', {
                        rules: [
                            infoRequired,
                        ]
                    })(
                        <Input placeholder="Insira seu RG" />
                    )}
                </Form.Item>
                <Form.Item
                    name="newPassword"
                    label={<NomeSenha />}
                >
                    {form.getFieldDecorator('newPassword', {
                            rules: [ infoRequired, validatePassword() ],
                        })(
                        <Input.Password  className="formInput" placeholder="Insira uma nova senha" />
                    )}
                </Form.Item> 
                <Form.Item
                    name="newPassConfirm"
                    label="Confirme sua senha"
                >
                    {form.getFieldDecorator('newPassConfirm', {
                            rules: [ 
                                {
                                    validator: (_, value, callback) => {
                                        if (value && value !== form.getFieldValue('newPassword')) {
                                            callback('As senhas informadas não correspondem')
                                        } else {
                                            callback()
                                        }
                                    }
                                }
                            ]
                        })(
                        <Input.Password  className="formInput mt-3" placeholder="Confirme sua nova senha" />
                    )}
                </Form.Item> 
                <hr />
                <Form.Item
                    name="password"
                    label="Senha atual"
                >
                    {form.getFieldDecorator('password', {
                            rules: [ infoRequired ]
                        })(
                        <Input.Password  className="formInput mt-3" placeholder="Senha atual" />
                    )}
                </Form.Item>  
                    {completeLoading ? <LoadingComponent /> :                                         
                    <button className="mt-3 text-center btnGrafico">Completar cadastro</button> }
            </Form>
        </div>
        )
    )
)

class CreateWallet extends PureComponent {
    constructor(props) {
        super(props)
        this.state = {
            modal: false
        }
    }

    
    openModal = () => {
        const aux = this.state.modal
        this.setState({
            modal: !aux
        })
    }

    componentDidUpdate(){
        const { completeSuccess } = this.props
        if(completeSuccess) {
            this.setState({
                modal: false
            })
        }
    }
    createBothWallets= async () => {
        this.props.createWallet()
        await finishWallet(this.props.user.nome, this.props.userid, '')
    }

    refreshThisPage= async () => {
        window.location.reload();
    }

         render() {
            const { user, isLoading, addressCreation, successCreation } = this.props
            const nomeMae = user.nomeMae
            const pass = user.ultimoUpdateSenha
            const fone = user.telefone
            const ultimos = fone[fone.length - 4]+fone[fone.length - 3]+fone[fone.length - 2]+fone[fone.length - 1]
           console.log(this.props);
            return (
                <>
                    <Container>
                        <Row>
                            <Col md={12} className="d-flex justify-content-center">
                                {this.props.step != 3 ?
                                    this.props.step == 1 && this.props.walletInfo.length === 0 ? 
                                        <div className="loginWalletWrapper">
                                            {this.props.success === false ? 
                                            <div className="alert alert-danger text-center" role="alert">
                                                {this.props.message}
                                            </div> : ''}
                                            {nomeMae === null || pass === null ? (
                                                <div className="alert alert-danger text-center mb-5 cursor-pointer" role="alert" >
                                                    Por favor <b role='button' onClick={this.openModal}> clique aqui </b> e atualize seu cadastro.
                                                    
                                                </div>
                                            ) : ''}
                                            {
                                                this.props.user && this.props.user.nivelVerificacao && this.props.user.nivelVerificacao !== '111' && (
                                                    <div className="alert alert-danger text-center mb-5 cursor-pointer w-50 m-auto" role="alert" onClick={this.openModal}>
                                                    Por favor, anexe seus documentos em <Link to="/minhaconta" style={{color: '#721c24', fontWeight: 'bold'}}>"Meus Dados"</Link>. Caso já tenha enviado, aguarde aprovação.
                                                </div>
                                                )
                                            }
                                            <center><img src={walletImg} alt="crypto wallet" className="img-fluid m-auto"/></center>
                                            <h4 className="tx-pink font-weight-bold mt-3">Você ainda não ativou sua wallet<br />Deseja ativar?</h4>
                                            {this.props.isLoading ? <LoadingComponent /> :
                                                this.props.user && this.props.user.nivelVerificacao && this.props.user.nivelVerificacao === '111' && nomeMae !== null && pass !== null ?
                                                    <Button onClick={this.createBothWallets} className="mt-3 text-center btnGrafico">Criar Wallet</Button> :
                                                    this.props.user && this.props.user.nivelVerificacao && this.props.user.nivelVerificacao !== '111' ? 
                                                        <BtnDisabled /> :
                                                            <Button onClick={this.openModal} className="mt-3 text-center btnGrafico">Criar Wallet</Button>                                                
                                                }
                                        </div>
                                    :  <div className="loginWalletWrapper loginWrapper">
                                            <h4 className="tx-pink font-weight-bold">Wallet criada com sucesso</h4>
                                            <Button onClick={this.refreshThisPage} className="mt-3 text-center btnGrafico"> ← Acessar para minha wallet</Button>
                    
                                            {/* {isLoading ? addressCreation ? <center><label className="text-center tx-blue pt-3 pb-3">Gerando seu endereço</label></center> : <center><label className="text-center tx-blue pt-3 pb-3">Criando sua Flow.in Wallet</label></center> : ''} */}
                                            {/* {successCreation === false ? 
                                            <div className="alert alert-danger text-center" role="alert">
                                                {this.props.message}
                                            </div> : ''} */}

                                            {/* <CreationForm ultimos={ultimos} isLoading={isLoading} token={this.props.token || setStateLocalStorage.creationToken} resendSMS={this.props.reSendSms} /> */}
                                        </div> 
                                : <LoginWallet /> }
                            </Col>
                        </Row>
                    </Container>
                    <Modal
                        title="Complete seu cadastro"
                        visible={this.state.modal}
                        onCancel={this.openModal}
                        footer={''}
                    >
                        <CompleteForm />
                    </Modal>
                </>
            )
        }
    }

export default connect(mapStateToProps, mapDispatchToProps)(CreateWallet)